module.exports = __webpack_public_path__ + "static/media/flash.940d73e6.svg";